export const PERSONA = "personas";
export const DEFAULT_PERSONA_PROMPT = "You are a helpful assistant.";
export const DEFAULT_PERSONA_NAME = "Default Persona";
export const DEFAULT_PERSONA_MODEL = "gpt-4o";